'use strict';

const { BackTabType } = require('./redemption-handler');

function getClientId(value = '') {
  return value ? value.split('.').slice(-2).join('.') : '';
}

function getSource(source, isTouch) {
  if (source) {
    return source;
  }

  if (isTouch) {
    return 'touch';
  }

  return 'web';
}

function isClickFromDirectLink(widgets) {
  return (
    Array.isArray(widgets) &&
    widgets.length &&
    (widgets[0].type === 'direct-link' ||
      widgets[0].path.toLowerCase().includes('redemption'))
  );
}

function isClickFromCouponWithNoCode(widgets) {
  return (
    Array.isArray(widgets) &&
    widgets.length &&
    widgets[0].type === 'coupon' &&
    widgets[0].metadata.type !== BackTabType
  );
}

function updateDirectLink(widgets, eventId) {
  const { element } = widgets[0];
  if (element.href) {
    const url = new URL(element.href);
    url.searchParams.set('eventId', eventId);

    element.setAttribute('href', url.href);
  }
}

function getPlatform(app, isTouch) {
  if (['ios', 'android'].includes(app)) {
    return app;
  }

  return getSource('', isTouch);
}

module.exports = {
  getClientId,
  getSource,
  isClickFromDirectLink,
  isClickFromCouponWithNoCode,
  updateDirectLink,
  getPlatform,
};
